import { useEffect } from "react";
import { auth } from "../firebase/firebaseConfig";
import { db } from "../firebase/firebaseConfig";
import { doc, onSnapshot } from "firebase/firestore";
import useFBstore from "../store/firebasestore";


function AuthProvider() {
  const setUserID = useFBstore((s) => s.setUserID);
  const setAuthStatus = useFBstore((s) => s.setAuthStatus);
  const setUsername = useFBstore((s) => s.setUsername);
  const setCartItems = useFBstore((s) => s.setCartItems);
  const setIsAdmin = useFBstore((s)=>s.setIsAdmin)
  const setUserEmail = useFBstore((s)=>s.setUserEmail)
  useEffect(() => {
    const unsubAuth = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        setUserID(null);
        setAuthStatus("unauthenticated");
        const isAdm = false;
        setIsAdmin(isAdm);

        return;
      }
    
      setUserID(user.uid);
      setAuthStatus("authenticated");
       const tokenResult = await user.getIdTokenResult();
    const isAdm = tokenResult.claims.admin || false;
    setIsAdmin(isAdm);

      // 2️⃣ Firestore user listener
      const userRef = doc(db, "Users", user.uid);

      const unsubUser = onSnapshot(userRef, (snapshot) => {
        if (!snapshot.exists()) return;

        const data = snapshot.data();

        setUsername(data.name);
        setCartItems(data.cartItems);
        setUserEmail(data.em)
     
      });

      // Cleanup Firestore listener when user logs out
      return () => unsubUser();
    });

    // Cleanup auth listener
    return () => unsubAuth();
  }, []);

  return null;
}

export default AuthProvider;
